import React from "react";
// import axios from "axios";
// import _ from "lodash";
const ethers = require("ethers");

export const Header = () => {


    let [connectedAddress, setConnectedAddress] = React.useState('');
    let [provider, setProvider] = React.useState('');

    const connectWallet = async () => {
      try {
        const { ethereum } = window;

        if (!ethereum) {
          alert("Please install MetaMask!")
          return;
        }

        let _provider = new ethers.providers.Web3Provider(ethereum)

        setProvider(_provider)

        const accounts = await ethereum.request({
          method: "eth_requestAccounts",
        });

        console.log("Connected", accounts[0]);
        setConnectedAddress(accounts[0])

      } catch (error) {
        console.log(error);
      }
    }

    const handleAccountChange = async () => {
        const accounts = await window.ethereum.request({
            method: "eth_requestAccounts",
        });

        setConnectedAddress(accounts[0])
        console.log('Account Changed', accounts[0])
    }

    React.useEffect(() => {
        window.ethereum.on("accountsChanged", handleAccountChange);
        return () => {
            window.ethereum.removeListener("accountsChanged", handleAccountChange);
        };
    });


    /*
      const login = async () => {
          let sign = await this.Web3.eth.sign(web3.utils.sha3("senshi"), this.connectedAddress)
          const send = await axios.post('http://indigo.com:8080/api/users', {
            params: {
              address: this.connectedAddress,
              sign: sign,
            },
            withCredentials: true
          })
          if(send.data.status === true) {
            this.isSigned = true
          } else {
            this.isSigned = false
          }
        }
    */

    React.useEffect(() => {
      // connectWallet();
    }, []);

const formatAddress = (address) => {
    if (!address) {
        return 'unknown';
    }
    return address?.toString()?.substring(0, 4) + '...' + address?.toString()?.substring(address.length - 4);
};

    return (
    <header style={{ marginTop: '35px', marginLeft: '45px', marginRight: '45px'}}>
     
        <div className="logo-text">
          <img src="./sachi2.png" style={{maxWidth: '50px',  position: 'relative', top: '-10px'}} />
          
        <div style={{float: 'right', fontSize: '13px', marginRight: '45px', paddingTop: '20px'}}>
            <p style={{display: 'inline-block'}}> <span className="header">33,333 $SACHI</span>  ↳  <span  style={{fontWeight: 'bold'}} className="header">0xPREVIEW...</span></p>
            <p style={{display: 'block'}}></p>
        </div>
        </div>
      </header>
    )
}